module.exports = __webpack_public_path__ + "media/logbook.647d1065.mp4";